<div class="modal-header">
  <h4 class="modal-title">Approvals Panel Help</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    ngbTooltip="Close"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>
<div class="modal-body apr-help-panel">
  <h2>What is the purpose of the Approvals panel?</h2>
  <p>
    As we continue to mature as a company, certain actions need to be reviewed
    and approved by a second set of eyes to ensure compliance with Audit
    requirements.
  </p>
  <p>
    The Approvals panel is the place where Requests for these High Risk Actions
    get Approved.
  </p>

  <h2>What High Risk Actions are there?</h2>
  <p>
    The original use case for this panel is the Force Recon Timestamp action.
    The list will likely grow in the future.
  </p>

  <h2>What is Force Recon Timestamp and how does it work?</h2>
  <p>
    Force Recon Timestamp allows you to assign a Recon TS to an account even if
    errors are flagging. This effectively means that actions like 'Pushing Stale
    Data', or 'Holiday Recon' now do not require non-value added actions like
    Holding all errors for a day.
  </p>
  <p>
    Apart from requiring an Approval in this panel, there are certain
    requirements for a request to be made:
  </p>
  <ol>
    <li>
      Force Recon TS is not allowed for Non-Active or Non-Reconciling Accounts
    </li>
    <li>Force Recon TS is not allowed for Aggregate Accounts</li>
    <li>Pricing TS is required on the requested Recon Date</li>
    <li>
      Force Recon TS is not allowed if any of the following breaks are present
      in the Account:
      <ul>
        <li>Client Restricted Security</li>
        <li>Orphan Transaction</li>
        <li>Missing Price</li>
        <li>Paydown with No Prediction</li>
        <li>Mismatched CAPI</li>
        <li>Mismatched Lot Links</li>
        <li>Missing Lot Link</li>
      </ul>
    </li>
    <li>
      Requested Recon Date must be equal to the Recon Date of the latest Perseus
      Run, or be before the latest Recon Timestamp on the Account
    </li>
  </ol>

  <h2>How do I navigate and use the Approvals panel?</h2>
  <p>
    Once a request is made, the Approvals Panel will display it in the Requests
    section. One request can contain multiple Accounts and Recon Dates. The
    count of Accounts and Ultimate Parent Clients contained in the Request is
    displayed, as well as the number of active errors across all Accounts in the
    Request.
  </p>
  <p>
    The exact content of the selected Requests can be found in the Request
    Details section. The smallest 'unit' of a Request is an Account ID - Recon
    Date combination. Approvals can be made either for a whole request (or
    multiple requests), or for a specific Account - Recon Date combination
    within a Request.
  </p>
  <p>
    In both sections, the count of Active Errors is also segmented into three
    buckets, to give Approvers quick insight into the state of the accounts they
    are approving:
  </p>
  <ol>
    <li>
      Missing External Positions
      <ol type="a">
        <li>
          It is expected that most Requests for Force Recon TS will have most if
          not all of their errors in this category
        </li>
      </ol>
    </li>
    <li>
      High Risk Errors
      <ol type="a">
        <li>
          Certain errors are deemed High Risk and will require further scrutiny
          before an Approval is made. These are:
        </li>
        <ol type="i">
          <li>Unentered Transactions</li>
          <li>Incorrect Positions</li>
          <li>Inconsistent Lot Entry & Exit</li>
        </ol>
      </ol>
    </li>
    <li>
      Other Errors
      <ol type="a">
        <li>
          All other errors that do not fall into one of the above categories
          will be counted here.
        </li>
      </ol>
    </li>
  </ol>
  <p>All Approvals will require a minimum-three-word note from the Approver.</p>
  <p>
    Once Approved, a run will be submitted for the given set of accounts that
    will carry out the specified action.
  </p>
  <h2>What do the different Request Statuses mean?</h2>
  <p>A request can have one of four Statuses:</p>
  <ol>
    <li>
      Approved
      <ol type="a">
        <li>The whole request has been Approved.</li>
      </ol>
    </li>
    <li>
      Denied
      <ol type="a">
        <li>The whole request has been Denied.</li>
      </ol>
    </li>
    <li>
      Pending
      <ol type="a">
        <li>
          There is at least one Account-Recon Date combination in the request
          that has been neither Approved nor Denied yet.
        </li>
      </ol>
    </li>
    <li>
      Reviewed
      <ol type="a">
        <li>
          The whole request has been actioned, but some Account-Recon Date
          combinations have been Approved and some Denied.
        </li>
      </ol>
    </li>
  </ol>
</div>
